/**
 * Baacal — PDP Judge.me reviews mount (draft).
 *
 * Why: Stars (preview badge) reflect product review metafields, but desktop CSS hid the
 * real apps-section widget and left an empty under-gallery shell → "N reviews" at top,
 * "Be the first" / white space when scrolling.
 *
 * How: On desktop (≥768), move the first apps-section .jdgm-review-widget into the
 * under-gallery mount. On mobile, leave the apps section in place and keep the mount empty.
 */
(function () {
  var MQ = window.matchMedia('(min-width: 768px)');
  var MOUNT_SEL = '[data-baacal-reviews-under-gallery]';
  var WIDGET_SEL = '.jdgm-review-widget';
  var MARK = 'data-baacal-reviews-home';

  function appsWidget() {
    var nodes = document.querySelectorAll(
      '.shopify-section ' + WIDGET_SEL + ':not(' + MOUNT_SEL + ' ' + WIDGET_SEL + ')'
    );
    for (var i = 0; i < nodes.length; i++) {
      var section = nodes[i].closest('.shopify-section');
      if (section && section.querySelector('.product-single__wrapper')) continue;
      return nodes[i];
    }
    return null;
  }

  function ensureHome(widget) {
    if (!widget || widget.getAttribute(MARK)) return;
    var home = document.createElement('div');
    home.setAttribute(MARK, '1');
    home.style.display = 'contents';
    widget.parentNode.insertBefore(home, widget);
    home.appendChild(widget);
  }

  function sync() {
    var mount = document.querySelector(MOUNT_SEL);
    if (!mount) return;
    var widget = appsWidget();
    if (!widget) return;
    ensureHome(widget);
    var home = widget.closest('[' + MARK + ']');
    if (MQ.matches) {
      if (widget.parentNode !== mount) mount.appendChild(widget);
      if (home) home.setAttribute('data-baacal-reviews-empty', '1');
      mount.setAttribute('data-baacal-reviews-filled', '1');
    } else {
      if (home && widget.parentNode !== home) home.appendChild(widget);
      if (home) home.removeAttribute('data-baacal-reviews-empty');
      mount.removeAttribute('data-baacal-reviews-filled');
    }
  }

  function boot() {
    sync();
    document.addEventListener('jdgm.doneInitialized', sync);
    if (typeof MQ.addEventListener === 'function') MQ.addEventListener('change', sync);
    else if (typeof MQ.addListener === 'function') MQ.addListener(sync);
    // Judge.me sometimes paints late
    setTimeout(sync, 500);
    setTimeout(sync, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
